<template>
  <div class="summary-slide">
    <img :src="require('@/assets/meitav-dash/meitav-dash-present.svg')" width="105px" height="117px">
    <div class="r-text-regular">קופת גמל להשקעה</div>
    <div class="r-image-headline">בשביל {{firstName}}</div>
    <div class="text-riseup-yellow r-image-headline">{{ formatAmount(monthlyDepositSum) }} ₪</div>
    <div>
      <div class="bg-riseup-yellow deposit">
        <span class="text-riseup-black r-text-regular">הפקדה חודשית</span>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyFormat from '@/mixins/MoneyFormat';

export default {
  name: 'SummarySlide',
  mixins: [MoneyFormat],
  props: {
    monthlyDepositSum: {
      required: true,
      type: Number,
    },
    firstName: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>

.summary-slide {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-content: center;

  img {
    align-self: center;
    margin-bottom: 8px;
    margin-top: -25px;
  }

  .deposit {
    display: inline-block;
    padding: 0 10px;
    margin-top: 5px;
  }
}

</style>
